import React, { Component, Fragment } from 'react';
import autoBind from 'react-autobind';
import { connect } from '@common/components/base.component';
import navbarActions from '@common/store/navbar/navbar.actions';
import Form from '@common/components/validation/form.validation';
import PasswordStrength from '@common/components/passwordStrength/passwordStrength.component';
import DDados from './navbar.changePassword.ddados';
import DDadosItem from '@common/components/ddados/ddados.item';
import SmartModal from '@common/components/modals/smartModal';
import { Modal, Row, Col } from 'react-bootstrap';

class NavbarChangePassword extends Component {
  constructor(props) {
    super(props, DDados);
    autoBind(this);
  }

  onSubmit(values) {
    this.props.navbarActions.updatePassword(values);
  }

  get initialValues() {
    return {
      SenhaAtual: undefined,
      NovaSenha: undefined,
      ConfirmarSenha: undefined,
    };
  }

  render() {
    const { Campos } = DDados;
    const { showChangePasswordModal, onClose } = this.props;

    return (
      <SmartModal show={showChangePasswordModal} size="lg" backdrop="static" onHide={onClose} keyboard>
        <Modal.Header>
          <Modal.Title>
            <h3>Alteração de senha</h3>
          </Modal.Title>
        </Modal.Header>

        <Form
          className="box-form-cadastro"
          onSubmit={this.onSubmit}
          onCancel={onClose}
          initialValues={this.initialValues}
        >
          {(form) => (
            <Fragment>
              <Modal.Body>
                <Row>
                  <Col lg={6}>
                    <DDadosItem name="SenhaAtual" {...Campos.SenhaAtual} />
                  </Col>
                </Row>

                <Row>
                  <Col lg={6}>
                    <DDadosItem name="NovaSenha" {...Campos.NovaSenha} />
                    <PasswordStrength password={form.values.NovaSenha} />
                  </Col>
                </Row>

                <Row>
                  <Col lg={6}>
                    <DDadosItem name="ConfirmacaoSenha" {...Campos.ConfirmarSenha} />
                  </Col>
                </Row>
              </Modal.Body>
            </Fragment>
          )}
        </Form>
      </SmartModal>
    );
  }
}

export default connect({
  actions: { navbarActions },
})(NavbarChangePassword);
